import { useRef } from 'react'

function useLazyRef(initialize) {
  const lazyRef = useRef(null)
  if (lazyRef.current === null) {
    lazyRef.current = initialize()
  }

  return lazyRef.current
}

export default useLazyRef
